<template>
  <div id="game-container"></div>
</template>

<script>
import { initPhaserGame } from "../phaser/novel.js";

export default {
  name: "NovelGame",
  mounted() {
    initPhaserGame();
    window.addEventListener("resize", () => {
      // 画面回転やリサイズ対応
      const game = window.__PHASER_GAME__;
      if (game) game.scale.refresh();
    });
  }
};
</script>

<style scoped>
#game-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: #000;
  margin: 20px auto;
  width: 800px;
  height: 600px;
}

.-mobile #game-container {
  width: 100vw;
  height: calc(100vh - 60px);
  margin: 0 auto;
}

.-mobile canvas {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>
